import dayjs from 'dayjs'
import utc from 'dayjs/plugin/utc'

export const DATE_FORMAT = {
  DATE_PICKER: 'DD/MM/YYYY',
  DEFAULT: 'DD MMM, YYYY',
  WITH_TIME: 'HH:mm, DD MMM, YYYY',
} as const

export const formatDate = (date: Date, format: string, convertToUtc?: boolean): string => {
  if (convertToUtc) {
    dayjs.extend(utc)

    return dayjs(date).utc().format(format)
  }

  return dayjs(date).format(format)
}
